<svg width="20" height="20">
    <line [ngClass]="color" x1="10" y1="0" x2="10" y2="20"></line>
</svg>
